module.exports = __webpack_public_path__ + "static/assets/4d3c9bb044487b09ac11088a04d60571.svg";